<template>
  <div class="bg-color-from-nrs-plus min-height-100vh">
    <v-container>
      <v-row>
        <v-col class="align-center d-flex justify-center justify-lg-start">
          <img
            alt="logo"
            height="270"
            width="207"
            srcset="
              @/assets/logo/redirect/nrslogovectorallwhitestacked@2x.png 2x,
              @/assets/logo/redirect/nrslogovectorallwhitestacked@3x.png 3x,
              @/assets/logo/redirect/nrslogovectorallwhitestacked@4x.png 4x
            "
            src="@/assets/logo/redirect/nrslogovectorallwhitestacked.png"
          />
        </v-col>
      </v-row>
    </v-container>
    <v-container class="d-flex flex-column">
      <v-row>
        <v-col
          cols="12"
          lg="6"
          class="align-lg-center d-flex flex-column pb-10 white--text"
        >
          <div class="text-center text-lg-left">
            <div class="pb-10 font-size-lg-res">
              Sorry, this web store is not active at the moment...
            </div>
            <div class="font-size-sm-res text-center text-lg-left">
              You are being redirected to NRSgo.com.
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="6" class="align-lg-center d-flex justify-center">
          <div class="d-flex flex-column">
            <v-btn
              class="mb-5"
              :height="responsiveButtonHeight"
              :loading="retrying"
              :width="responsiveButtonWidth"
              rounded
              @click.stop="retry"
            >
              <span class="font-size-md text-capitalize">retry</span>
            </v-btn>
            <v-btn
              :height="responsiveButtonHeight"
              :width="responsiveButtonWidth"
              rounded
              @click.stop="redirect"
            >
              <span class="font-size-md">ok</span>
            </v-btn>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import urls from "@/urls.json";
const millisecondsUntilAutomaticRedirect = 15000;

export default {
  name: "Redirect",
  created() {
    this.setTimer();
  },
  computed: {
    responsiveButtonHeight() {
      return this.$vuetify.breakpoint.lgAndUp ? 52 : 40;
    },
    responsiveButtonWidth() {
      return this.$vuetify.breakpoint.lgAndUp ? 180 : 130;
    },
  },
  data() {
    return { retrying: null, timerReference: null };
  },
  methods: {
    redirect() {
      window.location.href = urls.NRS_GO;
    },
    async retry() {
      this.retrying = true;
      await this.$store.dispatch("store/fetch");
      this.retrying = false;
    },
    setTimer() {
      this.timerReference = setTimeout(() => {
        window.location.href = urls.NRS_GO;
      }, millisecondsUntilAutomaticRedirect);
    },
  },
};
</script>
<style scoped>
.bg-color-from-nrs-plus {
  background-color: #b99cc8;
}

.min-height-100vh {
  min-height: 100vh;
}

.font-size-lg-res {
  font-size: 2rem;
  line-height: 1;
}

@media (min-width: 768px) {
  .font-size-lg-res {
    font-size: 3rem;
  }
}
@media (min-width: 960px) {
  .font-size-lg-res {
    font-size: 3.5rem;
  }
}
@media (min-width: 1264px) {
  .font-size-lg-res {
    font-size: 4rem;
  }
}

.font-size-sm-res {
  font-size: 1.2rem;
  line-height: 1;
}
@media (min-width: 768px) {
  .font-size-sm-res {
    font-size: 1.5rem;
  }
}
@media (min-width: 960px) {
  .font-size-sm-res {
    font-size: 2rem;
  }
}
@media (min-width: 1264px) {
  .font-size-sm-res {
    font-size: 2.5rem;
  }
}
</style>
